import React, { useState, useEffect } from "react";
import './DetailsofAddress.css';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

const DetailsofAddress = ({ onNext, onPrevious }) => {
  const [addressformData, setAddressFormData] = useState({
  doorNo: '',
  street: '',
  landmark: '',
  state: '',
  district: '',
  block: '',
  panchayat: '',
  pincode: '',
  country: ''
});

  const [errors, setErrors] = useState({});
const [formErrors, setFormErrors] = useState({});
useEffect(() => {
  try {
    const savedData = localStorage.getItem('addressData');
    if (savedData) {
      const parsedData = JSON.parse(savedData);
      setAddressFormData(parsedData);
    }
  } catch (err) {
    console.error("Failed to parse addressData", err);
  }
}, []);


useEffect(() => {
  localStorage.setItem('addressformData', JSON.stringify(addressformData));
}, [addressformData]);

 const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAddressFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // const handleSelectChange = (field, selectedOption) => {
  //   setAddressFormData(prev => ({
  //     ...prev,
  //     [field]: selectedOption
  //   }));
  //   setErrors(prev => ({
  //     ...prev,
  //     [field]: null
  //   }));
  // };
// const validate = () => {
//   const newErrors = {};
//   const requiredFields = ["state", "district", "block", "panchayat"]; 

//   requiredFields.forEach(field => {
//     if (!addressformData[field]) {
//       newErrors[field] = "This field is required.";
//     }
//   });

//   setErrors(newErrors);
//   return Object.keys(newErrors).length === 0;
// };

const handleSubmit = (e) => {
  e.preventDefault();
  console.log('Submitting form...');
  console.log('addressData:', addressformData);
  localStorage.setItem('addressData', JSON.stringify(addressformData));
  onNext(); // Make sure this leads to the next step
};

  return (
    <React.Fragment>
      <div className="deatilsofaddress-container">
        <div className="deatilsofaddress">
          <div className="deatilsofaddress-container-an">
            <form onSubmit={handleSubmit}>
              <h2 className="premanentdeatilsofaddress-heading">Address Details</h2>
              <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''}`}>
                
                    <input name="doorNo" placeholder=" " className="did-floating-input" value={addressformData.doorNo} onChange={handleInputChange}/>
                    <label className="did-floating-label"><span className="label-text">Door&nbsp;No</span></label>
              </div>
              <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''}`}>
                
                <input name="street" placeholder=" " className="did-floating-input" value={addressformData.street} onChange={handleInputChange} />
                <label className="did-floating-label"><span className="label-text">Street</span></label>
              </div>
              <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''}`}>
               
                  <input name="landmark" placeholder=" " className="did-floating-input" value={addressformData.landmark} 
                   onChange={(e) => { const value = e.target.value; if (/^[a-zA-Z\s]*$/.test(value)) {handleInputChange(e);}}}/>
                   <label className="did-floating-label"><span className="label-text">Landmark</span></label>
              </div>
             <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''}`}>
                
                <input name="panchayat" placeholder=" " className="did-floating-input"
                  value={addressformData.panchayat} onChange={(e) => { const value = e.target.value;
                        if (/^[a-zA-Z\s]*$/.test(value)) {handleInputChange(e); } }} />
                  <label className="did-floating-label"><span className="label-text">Panchayat</span></label>
                {errors.panchayat && <span className="error">{errors.panchayat}</span>}
              </div>
             <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''}`}>
                
                <input name="block" placeholder=" " className="did-floating-input" value={addressformData.block} 
               onChange={(e) => { const value = e.target.value; if (/^[a-zA-Z\s]*$/.test(value)) {handleInputChange(e);}}} />
                <label className="did-floating-label"><span className="label-text">Block</span></label>
                {errors.block && <span className="error">{errors.block}</span>}
            </div>
              <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''}`}>
                 
                  <input name="district" className="did-floating-input" placeholder=" " value={addressformData.district} 
                   onChange={(e) => { const value = e.target.value; if (/^[a-zA-Z\s]*$/.test(value)) {handleInputChange(e);}}}/>
                   <label className="did-floating-label"><span className="label-text">District</span></label>
                  {errors.district && <span className="error">{errors.district}</span>}
                </div>
              <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''}`}>
                  
                  <input type="text" placeholder=" " className="did-floating-input" name="pincode" value={addressformData.pincode}
                    onChange={handleInputChange} maxLength="6" pattern="^[0-9]{6}$"/>
                    <label className="did-floating-label"><span className="label-text">Pin&nbsp;Code</span></label>
              </div>
               <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''}`}>
                  
                  <input name="state" placeholder=" " className="did-floating-input" value={addressformData.state} 
                   onChange={(e) => { const value = e.target.value; if (/^[a-zA-Z\s]*$/.test(value)) {handleInputChange(e);}}}/>
                  <label className="did-floating-label"><span className="label-text">State</span></label>
                  {errors.state && <span className="error">{errors.state}</span>}
                </div>
              
             
              <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''}`}>
                  
                  <input type="text" placeholder=" " className="did-floating-input" name="country" value={addressformData.country} 
                  onChange={(e) => { const value = e.target.value; if (/^[a-zA-Z\s]*$/.test(value)) {handleInputChange(e);}}} />
                  <label className="did-floating-label"><span className="label-text">Country</span></label>
              </div>

               <div className='deatilsofaddress-btns-div'>
              <button type="button" className="deatilsofaddress-btn" onClick={onPrevious}>Previous</button>
              <button type="submit" className="deatilsofaddress-btn-next">Next</button>
            </div>
            </form>
           
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
export default DetailsofAddress;